import type { MarkdownToJSX } from "markdown-to-jsx";

import { Text } from "@mantine/core";

export const baseOverride: MarkdownToJSX.Overrides = {
    Text: {
        component: Text,
    },
};
